<template>
    <div class="flex flex-col gap-6">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">Notable Diagnostic Tests Results: Biochemical Tests</h2>

        <div>
            <h3 class="text-base md:text-2xl font-semibold mb-3">Biochemical test results:</h3>
            <ul class="list-disc pl-4 font-light mb-6">
                <li>
                    Blood gas results showed severe metabolic acidosis with pH 7.183, HCO<sub>3</sub>−9.7, BE −16.9, and
                    pCO<sub>2</sub> 26.5<sup>1</sup>
                </li>
                <li>
                    Urine examination showed pH 6, leukocytes 3+, blood 4+, protein 1+, ketone 2+, and nitrite
                    negative<sup>1</sup>
                </li>
            </ul>

            <ul class="list-disc pl-4 font-light">
                <li>
                    Urine organic acid results showed a <span class="font-semibold">mild increase</span> in excretion of
                    glycolate with normal excretion of oxalate<sup>1</sup>
                    <ul class="list-inside list-['-_'] pl-6">
                        <li>
                            This case publication does not include the exact values or reference ranges of glycolate and
                            oxalate<sup>1</sup>
                        </li>
                        <li>
                            Increased urine glycolate in the presence of hyperoxaluria is suggestive, but not diagnostic
                            of PH1<sup>2</sup>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>

        <div>
            <h3 class="text-base md:text-2xl font-semibold mb-3">Notable Biochemical Tests Results</h3>

            <table
                class="w-full table-fixed border-collapse border-solid border-2 border-darkergrey font-light break-words"
            >
                <thead class="text-center text-white">
                    <tr class="bg-lightblue text-base md:text-lg">
                        <th class="p-3 border-solid border-2 border-darkergrey"></th>
                        <th class="p-3 border-solid border-2 border-darkergrey">Result</th>
                        <th class="p-3 border-solid border-2 border-darkergrey">Reference Range<sup>3–5</sup></th>
                    </tr>
                </thead>

                <tbody class="text-center text-sm md:text-base">
                    <tr class="bg-grey">
                        <td class="p-3 border-solid border-2 border-darkergrey">Urea, mmol/L</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">42.6</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">2.5–9.2</td>
                    </tr>
                    <tr class="bg-white">
                        <td class="p-3 border-solid border-2 border-darkergrey">Creatinine, μmol/L</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">1510</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">49–90</td>
                    </tr>
                    <tr class="bg-grey">
                        <td class="p-3 border-solid border-2 border-darkergrey">Sodium, mmol/L</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">125</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">136–145</td>
                    </tr>
                    <tr class="bg-white">
                        <td class="p-3 border-solid border-2 border-darkergrey">Potassium, mmol/L</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">5.6</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">3.4–5.0</td>
                    </tr>
                    <tr class="bg-grey">
                        <td class="p-3 border-solid border-2 border-darkergrey">Chlorine, mmol/L</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">98</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">100–110</td>
                    </tr>
                    <tr class="bg-white">
                        <td class="p-3 border-solid border-2 border-darkergrey">Calcium, mmol/L</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">1.5</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">2.20–2.60</td>
                    </tr>
                    <tr class="bg-grey">
                        <td class="p-3 border-solid border-2 border-darkergrey">Phosphate, mmol/L</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">3.15</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">0.90–1.80<sup>*</sup></td>
                    </tr>
                    <tr class="bg-white">
                        <td class="p-3 border-solid border-2 border-darkergrey">Magnesium, mmol/L</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">1.02</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">0.7–1.0</td>
                    </tr>
                    <tr class="bg-grey">
                        <td class="p-3 border-solid border-2 border-darkergrey">Uric acid, μmol/L</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">523</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">130–370*</td>
                    </tr>
                    <tr class="bg-white">
                        <td class="p-3 border-solid border-2 border-darkergrey">iPTH, pmol/L</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">55.8</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">1.6–6.9</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
